package com.devi3east.bashbuddy.footer.navigation

import androidx.compose.runtime.Composable
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.footer.ui.ContactUsRoute
import com.devi3east.bashbuddy.footer.ui.PrivacyPolicyScreen
import com.devi3east.bashbuddy.footer.ui.TermsOfServiceScreen

fun NavGraphBuilder.footerNavGraph(
    appState: AppState
) {
    composable(Screen.TermsOfServiceScreen.route) {
        TermsOfServiceNavEntry(
            appState = appState
        )
    }

    composable(Screen.PrivacyPolicyScreen.route) {
        PrivacyPolicyNavEntry(
            appState = appState
        )
    }

    composable(Screen.ContactUsScreen.route) {
        ContactUsNavEntry(
            appState = appState
        )
    }
}

@Composable
private fun TermsOfServiceNavEntry(
    appState: AppState
) {
    TermsOfServiceScreen(
        onBack = { appState.navController.popBackStack() },
        date = "October 31, 2025"
    )
}

@Composable
private fun PrivacyPolicyNavEntry(
    appState: AppState
) {
    PrivacyPolicyScreen(
        onBack = { appState.navController.popBackStack() },
        date = "October 31, 2025"
    )
}

@Composable
private fun ContactUsNavEntry(
    appState: AppState
) {
    ContactUsRoute(
        appState = appState
    )
}